import Theme4960 from '../themes/LMS-Courses.js'
import Theme5503 from '../themes/Brotherhood'
import Theme6403 from '../themes/DPSG'
import Theme6572 from '../themes/SGWS'
import Theme8628 from '../themes/Nextraq'
import Theme9566 from '../themes/Foley'
import Theme10253 from '../themes/SafetyAlliance'

export const SetThemeVars = (companyID) => {
  switch ( companyID ) {

    case ( 5191 ):
      return Theme4960

    // add all the others here...
    case ( 5503 ):
      return Theme5503

    case ( 6403 ):
      return Theme6403

    case ( 6572 ):
      return Theme6572

    case ( 8628 ):
      return Theme8628

    case ( 9566 ):
      return Theme9566

    case ( 10253 ):
      return Theme10253

    // default to lms courses
    default:
      return Theme4960

  }

}
